import {
  MODULE_CLICK,
  STASH,
  OVERLAY,
  BUTTON_SUBMISSION,
  MY_ACCOUNT_SETTINGS
} from '../constants';
import { getPageType, getSettingsPrefix, getWidgetTemplates } from '../page-context';

export const quotes = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('quotes.stash-click', ({ output = {} }) => {
    const id = output.id || null; // quote id / harmony component id / null
    const component = output.component || null; // view all / share / refresh / learn more / null

    const DDOEvent = {
      category: {
        primaryCategory: STASH,
      },
      eventInfo: {
        eventName: MODULE_CLICK
      },
      eventMode: STASH,
      stash: {
        pageType: getPageType(),
        content: {
          widgets: [{
            action: 'click',
            id,
            name: 'quotes',
            templates: getWidgetTemplates(),
            campaign: 'n/a',
            component,
            element: 'n/a',
          }]
        }
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('quotes.email-overlay-view', () => {
    const DDOEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: `${getWidgetTemplates()}: quotes: email quote`
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('quotes.share-submit', ({ output = {} }) => {
    // price and discounts / price only / no price or discounts
    const settings = `${getSettingsPrefix()}: share quote: email: ${output.settings || 'n/a'}`;

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('quotes.interaction-click', ({ output = {} }) => {
    const id = output.id || null; // harmony component id / null
    const component = output.component || null; // active quotes tab / expired quotes tab

    const DDOEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MODULE_CLICK
      },
      pageType: getPageType(),
      content: {
        widgets: [
          {
            action: 'interact',
            id,
            name: 'quotes',
            templates: getWidgetTemplates(),
            campaign: 'n/a',
            component,
            element: 'n/a',
          }
        ]
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};
